import { Component } from 'utils/jsx'
import Rectangle from 'abstractions/Rectangle'

export default class Image extends Component {
  beforeRender (props) {
    this.state = {
      rectangle: new Rectangle(props)
    }
  }

  template (props) {
    return (
      <image
        // Do not pass the <Image ref> prop
        {...Object.assign({}, props, { ref: undefined })}
        {...this.state.rectangle}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/paper/Image.js